import isNil from "lodash/isNil";
import React, { useEffect } from "react";
import InnerPanel from "./innerPanel";
import styles from "./rightSideDetailsPanel.module.css";
import { useResizeDetector } from "react-resize-detector";
const handlePreventDefault = (e) => {
    e.preventDefault();
};
export default function RightSideDetailsPanel(props) {
    var _a;
    const { height, ref } = useResizeDetector();
    useEffect(() => {
        var _a, _b;
        if (props.autoOpenByDataLength && props.onChangeOpen) {
            ((_a = props.data) === null || _a === void 0 ? void 0 : _a.length) === 1 && props.onChangeOpen(true);
            (!props.data || ((_b = props.data) === null || _b === void 0 ? void 0 : _b.length) === 0) && props.onChangeOpen(undefined);
        }
    }, [(_a = props.data) === null || _a === void 0 ? void 0 : _a.length, props.onChangeOpen, props.autoOpenByDataLength]);
    useEffect(() => () => {
        props.onChangeOpen && props.onChangeOpen(undefined);
    }, [props.documentId]);
    return !isNil(props.documentId) && props.open ? (React.createElement("div", { className: styles.container, onContextMenu: handlePreventDefault, ref: ref },
        React.createElement(InnerPanel, { key: props.documentId, documentId: props.documentId, data: props.data, height: height, onDataUpdate: props.onDataUpdate, documentObjects: props.documentObjects, tableColumns: props.tableColumns, canModifyAttributes: props.canModifyAttributes, onRowsPin: props.onRowsPin, onGetPreview: props.onGetPreview, onOpenGroupTableViewModal: props.onOpenGroupTableViewModal }))) : null;
}
RightSideDetailsPanel.defaultProps = {
    autoOpenByDataLength: true
};
